import axios from "axios";

export function useAWSWAFCaptchaAxios(
  onCaptchaEvent = (event: any) => console.log(event)
) {
  const captchaAxios = axios.create();

  function renderCaptcha() {
    document.body.style.cursor = "wait";
    // @ts-ignore
    document.getElementById("modalOverlay").style.display = "block";
    // @ts-ignore
    document.getElementById("modal").style.display = "block";

    return new Promise((resolve) => {
      onCaptchaEvent("onCaptchaRequired");
      // @ts-ignore
      window.AwsWafCaptcha.renderCaptcha(document.getElementById("captchaForm"), {
        onSuccess: (wafToken: unknown) => {
          // @ts-ignore
          document.getElementById("modalOverlay").style.display = "none";
          // @ts-ignore
          document.getElementById("modal").style.display = "none";
          onCaptchaEvent("onSuccess");
          console.log("WAF Token", wafToken);
          resolve(wafToken);
        },
        onLoad: () => {
          document.body.style.cursor = "default";
          onCaptchaEvent("onLoad");
        },
        onError: () => onCaptchaEvent("onError"),
        onPuzzleTimeout: () => onCaptchaEvent("onPuzzleTimeout"),
        onPuzzleIncorrect: () => onCaptchaEvent("onPuzzleIncorrect"),
        onPuzzleCorrect: () => onCaptchaEvent("onPuzzleCorrect"),

        apiKey:
          "EKDpYTYsFkMvhgWLQbNfe69/g9roLNbfIIqrYB9qrC8D9FNn9tdjCKjmAiEL6/kdopuZpgeneZqGJxYHDMW0NPRnAWffvra4Lchh7uQGNbUky2bE9Dl10Br4QJhr9C+pTv9hKndyVx23SucIjxBR6rEa27gJuDabnWUoDzpd8baSNDZvwwwKiFFpfwJt76g9P8BatHQYGHAJkslS70CQAhFkey5WWk3IM7QNVzzkfg6rpVMhSx0RihVaSZr/tmaVUVBtjm1DigaVQpDO/v000JW32rrnVKLPNdERZhD2oyJORWR0hOhbFkpAFJXxnIbY6bHehRgG8ApgIdJ/glnhxjSqxBZlVn1PnJNLoZelV2ERLEfW6B39tjAoBasYn6uV3hWIF+wKBd2QxqJM559aDhKrP71O1lIRBV038Pi0sZcsdT5mVD3eX5BljMLPyfV8yrtSOve0JwSg3t1KOqhWgDDVYkyNpBv90CxCFVYqe+xR7EjqC3Gu89KWII03niEsyDTkWVLcEvAysGOi1DsKGJhlxju9yaqv7Ldo8KFB/zBKlnNW8qOS963EY7QF49lUt9El66lRQBJBS18BFaLka4XTuYELXxHSkcdyCEua3Mhtp2c5Gl5i7sQCvWvSRZrx4Y9paYGQTNmMAeE0Bkwi1V3lE1V+WSIYl6R2AShU/Bo=_0_1",
      });
    });
  }

  const captchaRequired = (error: {
    response: { status: number; headers: { [x: string]: string } };
  }) =>
    // TODO: Check for the WAF header backend and frontend are on different domains this check should be enabled once both backend and frontend are on same domain
    // error.response.status === 405 && error.response.headers["x-amzn-waf-action"] === "captcha";
    error.response.status === 405;

  // Use an Axios interceptor to render the CAPTCHA if the WAF requires it
  captchaAxios.interceptors.response.use(
    (response) => response,
    async (error) => {
      console.log("Axios Hook Error", error);
      const isCaptchaError = captchaRequired(error);
      console.log("Is Captcha Error", isCaptchaError);
      if (isCaptchaError) {
        const token = await renderCaptcha();
        console.log("Captcha Token", token);
        return await captchaAxios.request(error.config);
      } else return Promise.reject(error);
    }
  );

  // Ensure a token exists before making the request
  captchaAxios.interceptors.request.use(
    (config) => {
      // @ts-ignore
      return window.AwsWafIntegration.getToken().then((token) => {
        // add the header x-aws-waf-token: token if doing cross domain requests
        // @ts-ignore
        config.headers["x-aws-waf-token"] = token;
        return config;
      });
    },
    (_) => Promise.reject(_)
  );

  return captchaAxios;
}
